import { api } from '../lib/apiClient.js';

/**
 * Shareable campaign form links.
 *
 * A link is a read-only snapshot of the composer's shareable fields (never the SMTP
 * password, recipient files or test recipients). Opening one only reads it; nothing
 * here sends or enqueues a campaign.
 */

/**
 * Creates a link. The raw token in the response is returned exactly once — the server
 * stores only its hash, so the URL cannot be shown again later.
 *
 * @param {{config: object, name?: string, expiresAt?: string|null}} body
 * @returns {Promise<{id, name, tokenHint, status, createdAt, expiresAt, token, path}>}
 */
export function createShareLink(body) {
  return api.post('/api/shared-templates', body);
}

/** @returns {Promise<{links: Array<object>}>} The caller's own links, newest first. */
export function listShareLinks(signal) {
  return api.get('/api/shared-templates', { signal });
}

/** Changes the expiry (`null` = never) and/or name of one of the caller's links. */
export function updateShareLink(id, changes) {
  return api.patch(`/api/shared-templates/${encodeURIComponent(id)}`, changes);
}

/** Revokes a link permanently. Idempotent. */
export function revokeShareLink(id) {
  return api.post(`/api/shared-templates/${encodeURIComponent(id)}/revoke`, {});
}

/**
 * Public, unauthenticated read of a link's snapshot.
 *
 * 404 `NOT_FOUND`, 410 `EXPIRED` / `REVOKED` arrive as ApiError with `code` set.
 * `notifyOnUnauthorized: false` because a visitor without a session is expected here.
 */
export function getPublicSharedTemplate(token, signal) {
  return api.get(`/api/public/shared-templates/${encodeURIComponent(token)}`, {
    signal,
    notifyOnUnauthorized: false
  });
}
